import { ViewType } from "@/components/common/dynamic-grid/helpers/GridEnums";

export const getIconButton = (type: string): string =>
{
    if (!type) return "";

    switch (type.toLowerCase())
    {
        case ViewType.Create:
        {
            return "fa-solid fa-plus";
        }
        case ViewType.Form:
        {
            return "fa-solid fa-page";
        }
        case ViewType.Acceptance:
        {
            return "fas fa-check";
        }
        case ViewType.Rejection:
        {
            return "fas fa-times";
        }
        case ViewType.Return:
        {
            return "fa-solid fa-turn-down-left";
        }
        case ViewType.Import:
        {
            return "fa-solid fa-file-import";
        }
        case ViewType.Resume:
        {
            return "fa-solid fa-play";
        }
        case ViewType.SetTargets:
        case ViewType.ChangeProcess:
        case ViewType.RemoveParticipants:
        {
            return "fa-solid fa-pen-to-square";
        }
        case ViewType.Edit:
        {
            return "fa-solid fa-pencil";
        }
        case ViewType.Delete:
        {
            return "fas fa-trash-alt";
        }
        case ViewType.FlowCanAccept:
        {
            return "fas fa-check";
        }
        case ViewType.FlowCanReject:
        {
            return "fa-solid fa-xmark-to-slot";
        }
        case ViewType.FlowCanSend:
        {
            return "fa-solid fa-paper-plane-top";
        }
        case ViewType.Redirect:
        {
            return "fas fa-share-from-square";
        }
        case ViewType.Translate:
        {
            return "fas fa-language";
        }
        case ViewType.MarkShareAsRead:
        {
            return "fas fa-eye";
        }
        case ViewType.groupChangeTargets:
        {
            return "fas fa-user-pen";
        }
        default: return "";
    }
};

export const getVariantButton = (type: string): string =>
{
    if (!type) return "primary";

    switch (type.toLowerCase())
    {
        case ViewType.Create:
        {
            return "primary";
        }
        case ViewType.Form:
        {
            return "secondary";
        }
        case ViewType.Acceptance:
        {
            return "success";
        }
        case ViewType.Rejection:
        {
            return "danger";
        }
        case ViewType.Return:
        {
            return "warning";
        }
        case ViewType.Resume:
        {
            return "warning";
        }
        case ViewType.SetTargets:
        {
            return "warning";
        }
        case ViewType.Edit:
        {
            return "warning";
        }
        case ViewType.Delete:
        {
            return "danger";
        }
        case ViewType.FlowCanAccept:
        {
            return "success";
        }
        case ViewType.FlowCanReject:
        {
            return "danger";
        }
        case ViewType.FlowCanSend:
        {
            return "primary";
        }
        case ViewType.Redirect:
        {
            return "warning";
        }
        case ViewType.ChangeProcess:
        {
            return "warning";
        }
        case ViewType.RemoveParticipants:
        {
            return "warning";
        }
        case ViewType.MarkShareAsRead:
        {
            return "warning";
        }
        default: return "primary";
    }
};
